import MessageBody from './MessageBody';

export default MessageBody;
